<div class="modal-backdrop" *ngIf="showModal" (click)="close()"></div>

<div class="modal-container" *ngIf="showModal">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-car"></i>
        <h2>Selecionar Veículo</h2>
      </div>
      <button class="btn-close" (click)="close()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Search Bar -->
    <div class="modal-search">
      <div class="search-input-container">
        <i class="fas fa-search search-icon"></i>
        <input 
          type="text" 
          class="search-input" 
          [(ngModel)]="searchTerm"
          (input)="onSearch()"
          placeholder="Buscar por placa, modelo, marca, cor ou chassi..."
          autofocus>
      </div>
    </div>

    <!-- Vehicle List -->
    <div class="modal-body">
      <div class="vehicles-list">
        <!-- Loading State -->
        <div class="loading-state" *ngIf="loading">
          <i class="fas fa-spinner fa-spin"></i>
          <p>Carregando veículos...</p>
        </div>

        <!-- Vehicle Items -->
        <div 
          *ngFor="let vehicle of filteredVehicles"
          class="vehicle-item"
          [class.selected]="selectedVehicle?.id === vehicle.id"
          (click)="selectVehicle(vehicle)">
          <div class="vehicle-icon">
            <i class="fas fa-car"></i>
          </div>
          <div class="vehicle-info">
            <div class="vehicle-primary">
              <span class="vehicle-placa">{{ vehicle.placa }}</span>
              <span class="vehicle-model">{{ vehicle.marca }} {{ vehicle.modelo }}</span>
            </div>
            <div class="vehicle-details">
              <span><i class="fas fa-calendar"></i> {{ vehicle.ano }}</span>
              <span><i class="fas fa-palette"></i> {{ vehicle.cor }}</span>
            </div>
            <div class="vehicle-chassi">
              <i class="fas fa-fingerprint"></i> Chassi: {{ vehicle.chassi }}
            </div>
          </div>
          <div class="vehicle-check" *ngIf="selectedVehicle?.id === vehicle.id">
            <i class="fas fa-check-circle"></i>
          </div>
        </div>

        <div class="no-results" *ngIf="!loading && filteredVehicles.length === 0">
          <i class="fas fa-search"></i>
          <p>Nenhum veículo encontrado</p>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="modal-pagination" *ngIf="!loading && totalPages > 1">
      <div class="pagination-info">
        <span>Mostrando {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, totalCount) }} de {{ totalCount }} veículos</span>
      </div>
      <div class="pagination-controls">
        <button 
          class="btn-pagination" 
          (click)="previousPage()" 
          [disabled]="currentPage === 1"
          type="button">
          <i class="fas fa-chevron-left"></i>
        </button>
        
        <button 
          *ngIf="getPageNumbers()[0] > 1"
          class="btn-pagination" 
          (click)="goToPage(1)"
          type="button">
          1
        </button>
        
        <span *ngIf="getPageNumbers()[0] > 2" class="pagination-ellipsis">...</span>
        
        <button 
          *ngFor="let page of getPageNumbers()"
          class="btn-pagination" 
          [class.active]="page === currentPage"
          (click)="goToPage(page)"
          type="button">
          {{ page }}
        </button>
        
        <span *ngIf="getPageNumbers()[getPageNumbers().length - 1] < totalPages - 1" class="pagination-ellipsis">...</span>
        
        <button 
          *ngIf="getPageNumbers()[getPageNumbers().length - 1] < totalPages"
          class="btn-pagination" 
          (click)="goToPage(totalPages)"
          type="button">
          {{ totalPages }}
        </button>
        
        <button 
          class="btn-pagination" 
          (click)="nextPage()" 
          [disabled]="currentPage === totalPages"
          type="button">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="close()" type="button">
        <i class="fas fa-times"></i>
        Cancelar
      </button>
      <button 
        class="btn btn-primary" 
        (click)="confirmSelection()" 
        type="button"
        [disabled]="!selectedVehicle || checkingExistingServiceOrders">
        <i class="fas" [class.fa-spinner]="checkingExistingServiceOrders" [class.fa-spin]="checkingExistingServiceOrders" [class.fa-check]="!checkingExistingServiceOrders"></i>
        {{ checkingExistingServiceOrders ? 'Verificando...' : 'Selecionar' }}
      </button>
    </div>
  </div>
</div>

<!-- Existing Service Orders Blocking Modal -->
<div class="existing-os-backdrop" *ngIf="showExistingServiceOrdersModal" (click)="closeExistingServiceOrdersModal()"></div>

<div class="existing-os-container" *ngIf="showExistingServiceOrdersModal">
  <div class="existing-os-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-exclamation-triangle"></i>
        <h2>Veículo já possui OS</h2>
      </div>
      <button class="btn-close" (click)="closeExistingServiceOrdersModal()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="existing-os-body">
      <p class="existing-os-message">
        Já existe(m) ordem(ns) de serviço para o veículo
        <strong *ngIf="blockedVehicle">{{ blockedVehicle.placa }}</strong>.
        Não é permitido atrelar este veículo.
      </p>

      <div class="existing-os-table-wrapper">
        <table class="existing-os-table">
          <thead>
            <tr>
              <th>Tipo OS</th>
              <th>Número</th>
              <th>Status</th>
              <th>Criação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let os of existingServiceOrders">
              <td>{{ os.tipoOS || '-' }}</td>
              <td>{{ os.numeroOS || '-' }}</td>
              <td>{{ os.status || '-' }}</td>
              <td>{{ os.createdAt ? (os.createdAt | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="closeExistingServiceOrdersModal()" type="button">
        <i class="fas fa-check"></i>
        OK
      </button>
    </div>
  </div>
</div>

